import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const TotvsIENHIntegrationFormSchema = zod
  .object({
    login: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    password: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    filial: zod
      .number({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
    nivel: zod
      .number({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
  })
  .merge(IntegrationFormSchema);
